import React from 'react'
import { Button } from 'semantic-ui-react'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import CreateEmergencyDocument from './createEmergencyDocument'

 const EmergencyDocument =({translate})=>{

    return(
        <CreateEmergencyDocument>
        {
        ({isLoading,openConfirmationPopup})=><Button size="mini"
        className='sv todo-button'
        onClick={()=>{
          if(!isLoading)
             openConfirmationPopup.current?.openPopup()
        }} >
            {isLoading && <CustomLoader inline size="mini" />}
          {translate("EMERGENCY_PROCEDURE") }
        </Button>
 }
      </CreateEmergencyDocument>
      
       
    )
}


export default React.memo(EmergencyDocument)